import { isNotNullOrUndefined, validateNotNullOrUndefined } from '@weft/utils';
import { useQuery } from 'react-query';
import { useContractRevisePagePlanCreateReasonParam } from './use-contract-revise-page-plan-create-reason-param';

export function useContractRevisePagePlanCreateReason(contractId: string) {
  const [planCreateReason] = useContractRevisePagePlanCreateReasonParam();

  const { data: validatePlanCreateReason } = useQuery({
    queryKey: ['contract', contractId, planCreateReason],
    queryFn: () => {
      validateNotNullOrUndefined(planCreateReason);

      return planCreateReason;
    },
    enabled: isNotNullOrUndefined(planCreateReason),
    suspense: true,
  });

  validateNotNullOrUndefined(validatePlanCreateReason);

  return validatePlanCreateReason;
}